import component from './additional-services.js';

component.name += 'New';

export default component;